import { ENUM__redux_action } from '@/state/_base/ENUM__redux_action';
import { PayloadAction } from '@reduxjs/toolkit';
import { DTO__entity_with_grid2d } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/DTO__entity_with_grid2d';
import { STATE__workspace } from '../STATE__workspace';

export const local_workspace_child_entity_set_current_viewed = (payload: DTO__entity_with_grid2d): PayloadAction<DTO__entity_with_grid2d> => ({
  type: ENUM__redux_action.WORKSPACE_CHILD_ENTITY_SET_CURRENT_VIEWED,
  payload,
});

export const init_local_workspace_child_entity_set_current_viewed = (state: STATE__workspace, action: PayloadAction<DTO__entity_with_grid2d>) => {
  if (action.payload._id == state.current_viewed_entity._id && action.payload.type == state.current_viewed_entity.type) return;

  state.current_viewed_entity = action.payload.clone();
};
